import { ExceptionDay, NominalDay } from "PFTypes/booking/booking_config";

const DAYS_MAP = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6
};

export const sortWeekdaysByMap = (days: NominalDay[] = []): NominalDay[] =>
  days.sort((dayA, dayB) => DAYS_MAP[dayA.dayName] - DAYS_MAP[dayB.dayName]);

export const mergeNominalDays = (
  formNominalDays: NominalDay[],
  nominalDays: NominalDay[],
  calendarId: number
) =>
  formNominalDays.map((nominalDay) => ({
    ...nominalDay,
    calendarId,
    id: nominalDays.find(({ dayName }) => dayName === nominalDay.dayName)?.id
  }));

export const mergeExceptionDays = (
  formExceptionDays: ExceptionDay[],
  exceptionDays: ExceptionDay[],
  calendarId: number
) =>
  formExceptionDays.map((exceptionDay) => ({
    ...exceptionDay,
    date: exceptionDay.date ?? "",
    calendarId,
    id: exceptionDays.find(({ date }) => date === exceptionDay.date)?.id
  }));
